import axios from 'axios'

export const getProducts = async (take = null, page = null, isSubscriptionVisible = false, isVisible = true) => {
  const response = await axios.get('/products', {
    params: {
      take,
      page,
      isSubscriptionVisible,
      isVisible
    },
  })

  return response.data.data
}
